/**
 * Contrato del listado de recepciones COMPLETADAS — anmat_task con
 * estado='trazado' filtradas por GLN. Cada item es un remito ya confirmado
 * al SNT.
 */

import { z } from 'zod';

export const RecepcionCompletadaSchema = z.object({
  id: z.number().int(),
  nRemito: z.string().nullable(),
  nFactura: z.string().nullable(),
  glnOrigen: z.string().nullable(),
  glnDestino: z.string().nullable(),
  razonSocialOrigen: z.string().nullable(),
  razonSocialDestino: z.string().nullable(),
  cantSeries: z.number().int().min(0),
  estado: z.string(),
  tracedAt: z.string().nullable(),
  createdAt: z.string().nullable(),
  totales: z.object({
    total: z.number().int().min(0),
    trazado: z.number().int().min(0),
    error: z.number().int().min(0),
  }),
});

export const RecepcionCompletadasResponse = z.object({
  items: z.array(RecepcionCompletadaSchema),
  total: z.number().int().min(0),
  limit: z.number().int().min(1),
  offset: z.number().int().min(0),
});

export type RecepcionCompletada = z.infer<typeof RecepcionCompletadaSchema>;
export type RecepcionCompletadas = z.infer<typeof RecepcionCompletadasResponse>;

export interface RecepcionCompletadasFilters {
  search?: string;
  /** YYYY-MM-DD */
  dateFrom?: string;
  /** YYYY-MM-DD */
  dateTo?: string;
  limit?: number;
  offset?: number;
}
